<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <UnitsTable></UnitsTable>
  </Layout>
</template>

<script>
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import UnitsTable from '../components/maintenance/units/unitsTable.vue';

export default {
  components: { Layout, PageHeader, UnitsTable },
  data() {
    return {
      title: 'Units',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'units',
          href: '/production/maintenance/units',
          active: true,
        },
      ],
    };
  },
};
</script>
